import { request } from "../../Services/Api"
import { buildFormData } from "../../Utils/utils"

export const getAlerts = (params) => request.api.get(`/restful_api/alerts/list/filter`, params)
export const getAlertsFilterOptions = (params) =>
  request.api.any({ method: "OPTIONS", url: "/restful_api/alerts/options/filter", params })
export const getAlertsOtherPage = (next) => request.api.get(next)
export const getAlertsStatistics = (params) =>
  request.api.get(`/restful_api/statistics/alerts`, params)
export const getAlertsExport = ({ business_id, isAdmin, file_name, ...params }) => {
  if (isAdmin) {
    return request.api.get("/restful_api/export-alerts/export_alerts_data/", params)
  } else {
    return request.api.get(
      `/restful_api/export-alerts/export_alerts_for_user/?business_id=${business_id}`,
      params
    )
  }
}
export const updateAlert = ({ alert_id, ...newAlertInfo }) =>
  request.api.patch(`/restful_api/alerts/update_alert/${alert_id}`, newAlertInfo)

export const pinAlert = ({ id, pin }) =>
  request.api.post(`/restful_api/alerts/${id}/${pin ? "pin" : "unpin"}`)

export const getAlertDetails = (alertID) => request.api.get(`/restful_api/alert_info/${alertID}/`)
export const getAlertLogs = (alertID) => request.api.get(`/restful_api/alert_logs/${alertID}/`)

export const getAlertDetailsExport = (alertID) =>
  request.api.get(`/restful_api/alert_info/${alertID}/download_alert/`)
export const createAlertTicket = ({ alert_id, ...data }) =>
  request.api.post(`/restful_api/alert_info/${alert_id}/create_support_ticket/`, data)

export const createCreditRequest = ({ id, data }) => {
  const formData = buildFormData(data, "file_list")
  return request.api.post(`/restful_api/alert_info/${id}/create_credit_request/`, formData)
}

export const alertsBulkResolve = (data) => {
  return request.api.post(`/restful_api/alerts/bulk_resolve`, data)
}
